import { Injectable } from '@angular/core'
import { LogService } from 'htv-lib'

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  channelOverlayDurationInMilliseconds = 5000

  constructor(private logService: LogService) {
    // do nothing
  }

  init(): void {
    this.logService.debug('ConfigService - Initialization')
  }
}
